package com.patronat.top.features.dashboard.data.network

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.ReviewFilterRequest
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.dto.ReviewModerationRequest
import com.patronat.top.dto.ReviewOwnerReplyRequest
import com.patronat.top.dto.ReviewResponse
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody

class ReviewModerationRemoteDataStore(
    private val httpClient: HttpClient
) {
    suspend fun getReviews(request: ReviewFilterRequest): NetworkResult<ReviewListResponse> {
        return safeApiCall {
            httpClient.post("reviews/filter") {
                setBody(request)
            }
        }
    }

    suspend fun moderateReview(reviewId: String, approved: Boolean): NetworkResult<ReviewResponse> {
        return safeApiCall {
            httpClient.put("reviews/$reviewId/moderation/review") {
                setBody(ReviewModerationRequest(approved = approved))
            }
        }
    }

    suspend fun getMyVenueReviews(request: ReviewFilterRequest): NetworkResult<ReviewListResponse> {
        return safeApiCall {
            httpClient.post("reviews/my-venues/filter") {
                setBody(request)
            }
        }
    }

    suspend fun replyToReview(reviewId: String, text: String): NetworkResult<ReviewResponse> {
        return safeApiCall {
            httpClient.put("reviews/$reviewId/reply") {
                setBody(ReviewOwnerReplyRequest(text = text))
            }
        }
    }
}
